export default __webpack_public_path__ + "static/media/open.af3bb8f0.svg";